import React from 'react'
import Table from '../../../../../common/components/table'


 
export default function WebsiteCardComponent ({onSearch,onDelete,additionButtons,rowData,columnDefs,onEdit,paginationData,setPageData}: any) {
  return (
    <>

<Table columnData={columnDefs} rowData={rowData}  enableFilter={true}
        onSearch={onSearch}     
     onEdit={onEdit} onDelete={onDelete} additionButtons={additionButtons} headingName="Website Cards"/>
             
   
        </>
  )
}